import { ArrayNotContainsValueBaseValueConverter } from 'General/Resources/ValueConverters/ArrayNotContainsValueBase';

export class ArrayNotContainsValueValueConverter extends ArrayNotContainsValueBaseValueConverter {
}